<template>
  <base-echart
    :options="option"
    @legendselectchanged="handleLegendSelectChange"
  />
</template>

<script>
import { getMasterDataText } from '../../helpers'

const colors = [
  '#ff7675', // red
  '#fdcb6e', // blue
  '#0984e3', // green
]

export default {
  props: [
    'items',
    'type',
    'selectedKey',
  ],

  computed: {
    diningOptions () {
      return this.items.reduce((acc, cur) => {
        cur.diningOptions.map((item) => item.diningType).forEach((diningOption) => {
          if (!acc.includes(diningOption)) {
            acc.push(diningOption)
          }
        })
        return acc
      }, [])
    },
    barChartLineChartOption () {
      const series = this.diningOptions.map((diningType, index) => {
        return {
          data: this.items.map((item) => {
            const result = item.diningOptions.find((itemPaymentMethod) => (
              itemPaymentMethod.diningType === diningType
            ))
            return result ? result[this.selectedKey] : null
          }),
          type: this.type,
          stack: 'a',
          name: getMasterDataText(diningType, this.$t) || this.$t('apps.reports.message.unspecifiedcategory'),
          label: {
            show: true,
            formatter: (params) => [null, '-', 0].includes(params.value) ? '' : params.value,
          },
          color: colors[index],
        }
      })
      return {
        legend: {
          selectedMode: true,
        },
        xAxis: {
          type: 'category',
          data: this.items.map((item) => item.date),
        },
        yAxis: {
          type: 'value',
        },
        series: series,
      }
    },
    pieChartOption () {
      return {
        color: colors,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            label: {
              show: true,
              formatter (param) {
                return param.name + ' (' + param.percent + '%)'
              },
            },
            data: this.diningOptions.map((diningType) => {
              return {
                value: this.items.reduce((acc, cur) => {
                  const total = cur.diningOptions.reduce((_acc, _cur) => {
                    if (_cur.diningType === diningType) {
                      _acc += _cur[this.selectedKey]
                    }
                    return _acc
                  }, 0)
                  return acc + total
                }, 0),
                name: getMasterDataText(diningType, this.$t) || this.$t('apps.reports.message.unspecifiedcategory'),
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    option () {
      if (this.type === 'bar' || this.type === 'line') {
        return this.barChartLineChartOption
      }
      return this.pieChartOption
    },
  },

  methods: {
    handleLegendSelectChange (params) {
      this.$emit('update:selected-labels', params.selected)
    },
  },
}
</script>

<style scoped>
.chart-container /deep/ .echarts {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ReportPosDiningOptionChart.vue